module.exports = __webpack_public_path__ + "components/rewards/ski-line/static/logo-a823de7ee933e7496743996a5dc11d08.webp";